module.exports = __webpack_public_path__ + "static/media/7_Confirm-Powered-Correctly-Red.42c4c757.svg";